import { useEffect } from "react";
import useHistory from "routing/useHistory";
import AzureRoutes from "./common/Routes";
const AzureLogsInputConfiguration = ({ url = AzureRoutes.INTEGRATIONS.Azure.ACTIVITYAPI.index }) => {
  const history = useHistory();
  useEffect(() => {
    history.push(url);
  }, [history, url]);
  return null;
};
export default AzureLogsInputConfiguration;
